module.exports = __webpack_public_path__ + "media/images/5-4fe6f3bf1b725eb00331a746934c6f11.jpg";